import $ from 'jquery';

// CVE-2015-9251 - fixes potential XSS attack. This is fixed in jQuery 3.x but we patch manually since
// we're on 2.x. See https://github.com/jquery/jquery/issues/2432
$.ajaxPrefilter((s: JQueryAjaxSettings) => {
  if (s.crossDomain) {
    s.contents!.script = false;
  }
});
